'use strict';
import { isValidExpression, valuesAreSet, valuesExpressionIsSet, valuesExpressionIsValid } from './validations';

angular.module('formApp').factory('validationHelper', [
  function () {
    var _isAlreadyDefinedInExternalValidation = function (fieldGroup, field, element, fieldGroupInstance) {
      var result = element.settings.fieldIds.some(function (definedField) {
        return (
          definedField.fieldId === field.id &&
          definedField.groupId === fieldGroup.id &&
          definedField.groupIndex === fieldGroupInstance
        );
      });

      return result;
    };

    var validateUrl = function (url) {
      return /^(?:https?:\/\/)(?:[\da-z\.-]+)(?:\.[a-z\.]{2,6})?(?:\:\d{2,5})?(?:[\/\w \.-]*)*\/?$/i.test(url);
    };

    const valuesOrValuesExpressionAreSetAndValid = (rule) => {
      if (valuesExpressionIsSet(rule.valuesExpression)) {
        return valuesExpressionIsValid(rule.values, rule.valuesExpression);
      }

      return valuesAreSet(rule.values);
    };

    const ruleOfTypeRequiredOnFieldValue = (rule) => {
      const ruleName = rule['@type'];
      return ruleName.indexOf('RequiredOn') === 0 && ruleName.indexOf('Value') !== -1;
    };

    const removeEmptyValuesExpression = (rule) => {
      if (rule.valuesExpression === '') {
        delete rule.valuesExpression;
      }
    };

    return {
      addRule: function (element, rule, $scope) {
        if (!rule) {
          return;
        }
        rule = angular.copy(rule);
        if (element.validationRules === undefined) {
          element.validationRules = [];
        }
        if (ruleOfTypeRequiredOnFieldValue(rule)) {
          if (!valuesOrValuesExpressionAreSetAndValid(rule)) {
            return;
          }

          removeEmptyValuesExpression(rule);
        }
        if (rule['@type'] === 'MaxDateValueValidator') {
          if (!rule.maxValue && !rule.maxValueExpression) {
            return false;
          }

          if (rule.maxValueExpression) {
            if (!isValidExpression(rule.maxValueExpression)) {
              alert('Der Platzhalter ist ungültig. Bitte geben Sie einen gültigen Platzhalterausdruck an.');
              return false;
            }
            delete rule.maxValue;
          }

          if (rule.maxValue) {
            rule.maxValue = rule.maxValue.getTime();
          }
        }

        if (rule['@type'] === 'MinDateValueValidator') {
          if (!rule.minValue && !rule.minValueExpression) {
            return false;
          }

          if (rule.minValueExpression) {
            if (!isValidExpression(rule.minValueExpression)) {
              alert('Der Platzhalter ist ungültig. Bitte geben Sie einen gültigen Platzhalterausdruck an.');
              return false;
            }
            delete rule.minValue;
          }

          if (rule.minValue) {
            rule.minValue = rule.minValue.getTime();
          }
        }

        if (rule['@type'] === 'ExternalValidator') {
          // validate URL
          if (!rule.settings.url || rule.settings.url === '') {
            alert('Es wird eine URL für die externe Validierung benötigt.');
            return false;
          } else if (!validateUrl(rule.settings.url)) {
            alert('Es wurde keine korrekte URL für die externe Validierung angegeben.');
            return false;
          }

          // validate fields if scope === DEFINED
          if (rule.settings.scope === 'DEFINED' && rule.settings.fieldIds.length === 0) {
            alert('Bitte geben Sie mindestens ein Feld an, welches übertragen werden soll.');
            return false;
          }
        }

        if (rule['@type'] === 'MaxDateValueValidator') {
          rule.maxValue = new Date(rule.maxValue);
        }
        if (rule['@type'] === 'MinDateValueValidator') {
          rule.minValue = new Date(rule.minValue);
        }
        if (rule['@type'] === 'MaxFileCountValidator') {
          // maxFileCount is undefined if value is lower than 1 or higher than 99 due to input type="number"
          if (!rule.maxFileCount) {
            alert('Bitte geben Sie eine Zahl zwischen 1 und 99 an.');
            return;
          }
        }
        if (rule['@type'] === 'FileExtensionValidator') {
          if (rule.values.length === 0) {
            alert('Bitte geben Sie mindestens eine Dateiendung an.');
            return;
          }
        }
        if (rule['@type'] === 'MaxFilesizeValidator') {
          if(!rule.maxFilesize || rule.maxFilesize <= 0) {
            alert('Bitte geben Sie eine Dateigröße in Byte größer 0 an.');
            return;
          }
        }
        if (rule['@type'] === 'FileNameRegexValidator' || rule['@type'] === 'RegexValidator') {
          if(!rule.regex) {
            alert('Bitte geben Sie einen regulären Ausdruck an.');
            return;
          }
        }
        if (rule['@type'] === 'MaxTotalFilesizeValidator') {
          if(!rule.maxTotalFilesize || rule.maxTotalFilesize <= 0) {
            alert('Bitte geben Sie eine gesamte Uploadgröße in Byte größer 0 an.');
            return;
          }
        }
        if (rule['@type'] === 'MinNumberValueValidator') {
          if(!rule.minValue) {
            alert('Bitte geben Sie einen minimalen Wert an.');
            return;
          }
        }
        if (rule['@type'] === 'MaxNumberValueValidator') {
          if(!rule.maxValue) {
            alert('Bitte geben Sie einen maximalen Wert an.');
            return;
          }
        }
        if (rule['@type'] === 'MaxLengthValidator') {
          if(!rule.maxLength || rule.maxLength <= 0) {
            alert('Bitte geben Sie eine maximalen Länge größer 0 an.');
            return;
          }
        }
        if (rule['@type'] === 'NumberValidator') {
          if(!rule.digitsAfterDecimalPoint) {
            alert('Bitte geben Sie eine positive Anzahl an Nachkommastellen an.');
            return;
          }
        }

        // prevent empty custom error messages
        var preventEmptyMessages = function (messageKeys) {
          messageKeys.map(function (item) {
            if (!rule[item] || rule[item].trim().length === 0) {
              delete rule[item];
            }
          });
        };

        var messageKeys = [
          'validationErrorMessage',
          'typeValidationFailedMessage',
          'requiredValidationFailedMessage',
          'decimalPointErrorMessage',
          'validationNonNegativeNumberError',
          'validationInvalidNumberMessage'
        ];

        preventEmptyMessages(messageKeys);

        // reset for new validation rule
        $scope.models.newValidationRule = null;
        $scope.models.newExternalValidationDefinedField = null;

        // push element as new rule
        element.validationRules.push(angular.copy(rule));
      },
      removeRule: function (element, rule) {
        var index = element.validationRules.indexOf(rule);
        element.validationRules.splice(index, 1);
      },
      setAvailableFields: function (element, newExternalValidationDefinedField, rule) {
        // unused third parameter: fieldGroupInstance
        var fields;
        if (newExternalValidationDefinedField && newExternalValidationDefinedField.fieldGroup) {
          fields = [];
          angular.forEach(newExternalValidationDefinedField.fieldGroup.rows, function (row) {
            fields = fields.concat(row.fields);
          });
        }

        if (!newExternalValidationDefinedField.fieldGroup || !newExternalValidationDefinedField.fieldGroup.multiple) {
          newExternalValidationDefinedField.instance = 0;
        }
        if (fields) {
          fields = fields.filter(function (field) {
            // check for already defined fields
            if (
              _isAlreadyDefinedInExternalValidation(
                newExternalValidationDefinedField.fieldGroup,
                field,
                rule,
                newExternalValidationDefinedField.instance
              )
            ) {
              return false;
            }
            return true;
          });
        }
        newExternalValidationDefinedField.availableFields = fields;
      },
      displayValue: function (value, hint) {
        if (hint && hint === 'DATE') {
          if (Object.prototype.toString.call(value) !== '[object Date]') {
            value = new Date(value);
          }
        }

        if (typeof value === 'boolean') {
          return value ? 'Ja' : 'Nein';
        } else if (Object.prototype.toString.call(value) === '[object Array]') {
          return value.join(', ');
        } else if (Object.prototype.toString.call(value) === '[object Date]') {
          if (isNaN(value.getDate())) {
            return;
          }
          return value.getDate() + '.' + (value.getMonth() + 1) + '.' + value.getFullYear();
        } else if (
          Object.prototype.toString.call(value) === '[object Object]' &&
          'groupId' in value &&
          'groupIndex' in value &&
          'fieldId' in value
        ) {
          return value.groupId + ':' + value.groupIndex + ':' + value.fieldId;
        }
        return value;
      },
      isCompositeProperty: function (property) {
        return 'properties' in property;
      },
      isButtonDisabled: function ($scope) {
        let model = $scope.models.newValidationRule;
        if (!model) {
          return true;
        }
        let enabled = model;
        if (model.sourceFieldKey) {
          enabled = enabled && model.sourceFieldKey.fieldId;
        }
        if (model.values) {
          enabled = enabled && model.values.length > 0 && model.values[0] !== '';
        }
        if (model.valuesExpression) {
          enabled = true;
        }
        return !enabled;
      }
    };
  }
]);
